import { H3 } from '@components/Typography';
import styled, { css } from 'styled-components';

export const TicketsWrapper = styled.div<{ color?: string }>`
  max-width: 1430px;
  margin: 0 auto;
  padding: 4rem 0 4rem 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 2rem 2rem;
  }

  .tito-widget-button {
    background-color: ${({ color, theme }) =>
      color ?? theme.color.mobilityGrey} !important;
    border: none !important;
    border-radius: ${({ theme }) => theme.borderRadius.radius10} !important;
    color: ${({ theme }) => theme.color.white} !important;
    font-size: ${({ theme }) => theme.fontSize.size22} !important;
    font-weight: ${({ theme }) => theme.fontWeight.weight700} !important;
    padding: 1.6rem 2.5rem !important;
    width: 100% !important;
    text-align: center !important;

    &:hover {
      background-color: ${({ theme }) => theme.color.mobilityGrey} !important;
      color: ${({ theme }) => theme.color.white} !important;
    }
  }
`;

export const TicketItemWrapper = styled.div<{
  backgroundColor?: string;
  hasBorderTop?: boolean;
  hasBorderBottom?: boolean;
  hasFullContent?: boolean;
}>`
  border-bottom: ${({ hasBorderBottom }) =>
    hasBorderBottom ? '4px solid #EDEDED' : `none`};
  border-top: ${({ hasBorderTop }) =>
    hasBorderTop ? `4px solid #EDEDED` : 'none'};
  max-width: ${({ hasFullContent }) => (!hasFullContent ? '100%' : '1134px')};
  margin: 0 auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    width: 100%;
    max-width: fit-content;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: 0;
    padding-bottom: 3rem;
    max-width: 100%;
  }

  .tito-release {
    display: none !important;
  }

  .tito-release-description {
    display: none !important;
  }

  .tito-price-details-regular {
    display: none !important;
  }

  .tito-discount {
    display: none !important;
  }

  .tito-widget {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .tito-widget-form {
    background: none !important;
    border: none !important;
    padding: 0 !important;
  }

  .tito-form-actions {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .tito-submit {
    ${({ backgroundColor }) =>
      backgroundColor
        ? css`
            background-color: ${backgroundColor} !important;
          `
        : css``};
    border: none !important;
    border-radius: 1rem !important;
    font-size: ${({ theme }) => theme.fontSize.size22} !important;
    font-weight: ${({ theme }) => theme.fontWeight.weight700} !important;
    width: 100% !important;
    min-width: 25rem !important;
    padding-top: 1.44rem !important;
    padding-bottom: 1.44rem !important;
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.color.mobilityGrey} !important;
    }
  }
`;

export const TicketItemContentWrapperInternal = styled(TicketItemWrapper)`
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    max-width: 100%;
  }
`;

export const TicketItemContentWrapper = styled.div`
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin: 0;
  }
`;

export const TitleText = styled(H3)`
  font-size: ${({ theme }) => theme.fontSize.size30};
  padding-top: 5rem;
  padding-bottom: 3rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const TicketContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  font-size: ${({ theme }) => theme.fontSize.size18};

  li {
    margin-top: 0.75rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
    font-size: ${({ theme }) => theme.fontSize.size16};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    display: block;
  }
`;

export const LeftColumn = styled.div`
  align-self: end;
  margin-bottom: 4rem;

  ul {
    padding-left: 0;
    list-style: none;
  }

  li {
    position: relative;
    padding-left: 1rem;
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }

  li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    color: currentColor;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding-right: 0;
    padding-left: 0;

    li {
      padding-right: 0;
      padding-left: 0;
    }
  }
`;

export const LeftColumnTop = styled(LeftColumn)`
  margin-left: 1rem;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-self: end;
  justify-self: end;
  text-align: right;
  margin-bottom: 4rem;
`;

export const Price = styled.div<{ color?: string; textDecoration?: string }>`
  color: ${({ theme, color }) => color || theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  text-decoration: ${({ textDecoration }) => textDecoration || 'none'};
  margin-bottom: 1.5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    margin-bottom: 0rem;
  }
`;

export const VATText = styled.div`
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size12};
  }
`;

export const SubtitleText = styled.div<{
  color?: string;
  fontSize?: string;
  fontWeight?: string;
}>`
  color: ${({ theme, color }) => color || theme.color.mobilityGrey};
  font-size: ${({ theme, fontSize }) => fontSize || theme.fontSize.size22};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight || theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height140};

  margin-top: 8rem;
  margin-bottom: 3rem;
  max-width: 45rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size18};

    margin-top: 0;
    margin-bottom: 3rem;
  }
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.color.error};
  font-size: ${({ theme }) => theme.fontSize.size16};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  margin-top: 1rem;
`;

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;

  div[data-testid='regular-button'] {
    opacity: 0.3;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    gap: 1rem;
  }
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const MobilePriceVatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
`;

export const Input = styled.input<{
  width?: string;
  height?: string;
  padding?: string;
  color?: string;
}>`
  border-radius: 1rem;
  border: 3px solid ${({ theme }) => theme.color.grey1};
  color: ${({ color, theme }) => color || theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size22};
  text-align: center;

  height: ${({ height }) => height || '52px'};
  width: ${({ width }) => width || '100px'};
  padding: ${({ padding }) => padding || '0'};

  &::placeholder {
    color: ${({ theme }) => theme.color.mobilityGrey};
    opacity: 1;
    transition: color 0.2s;
  }
  &:focus::placeholder {
    color: transparent;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
  }
`;

export const IframeContainer = styled.div`
  grid-column: 1 / -1;
  margin-top: 2rem;
  width: 100%;
  height: auto;
`;

export const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  overflow: hidden;

  iframe {
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.radius10};
  }
`;
